'use client';

import { type HTMLAttributes, type ReactNode } from 'react';

import { clsx } from '@/libs';

type BottomFixedProps = HTMLAttributes<HTMLDivElement> & {
  children?: ReactNode;
  hasFooter?: boolean;
};

export const BottomFixedRoot = ({
  children,
  hasFooter = false,
  className,
  ...props
}: BottomFixedProps) => {
  return (
    <div
      className={clsx(
        'fixed lg:static z-40',
        'inset-x-0 lg:inset-auto',
        hasFooter ? 'bottom-0 lg:bottom-auto' : 'bottom-0',
        'bg-background-grey',
        'rounded-t-3xl',
        'p-2.5 md:p-0 flex flex-col gap-2 shadow-2xl md:shadow-none shadow-foreground',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};
